/**
 *  Filename ....: imgverify.component.ts
 *  Created by ..: ianday
 *  on Date .....: 4/28/23
 **/
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MedicationService } from '../../../../../services/medication.service';
import { MedicationImage } from '../../../../../models/medicationimage';
import { Settings } from '../../../../../services/settings';
import { MatTableDataSource } from '@angular/material/table';
import { Medication } from 'src/app/models/medication';
import { MedicationFamily } from 'src/app/models/medicationfamily';
import { QuickaddmedicationComponent } from '../dialogs/quickaddmedication/quickaddmedication.component';

export class ImageUrls {
	tabletUrl: string;
	containerUrl: string;
	sampledBy: string;
	sampledDate: string;
}
export class ImgVerify {
	select: boolean;
	imageType: string;
	imageUrl: string;
	id: number;

}
@Component({
	selector: 'app-imgverify',
	templateUrl: './imgverify.component.html',
	styleUrls: ['./imgverify.component.css']
})

export class ImgVerifyComponent implements OnInit {

	public tabletUrl: string;
	public containerUrl: string;
	public medicationService: MedicationService;
	public ndcNumber: string;
	public imageList: any;
	public BASE_URL = Settings.getInstance().BASE_URL;
	public strErr = '';
	public medicationImages: MatTableDataSource<ImgVerify>;
	public displayedColumns = ['validated', 'imageType', 'imageUrl'];
	public Idx = -1;
	public dispLargeImage: boolean | null = false;
	public largeImgUrl: any;
	public noImageFlag = false;
	public sampledBy: string = '';
	public sampledDate: string = '';
	public selectedMedication: Medication;
	public selectedFamily: MedicationFamily;
	public ingredients: any;

	displayQuickMedicationAddEditDlg = false;

	@Output() cancelImgVerify: EventEmitter<any>;
	@Output() submittedImgVerify: EventEmitter<any>;
	@ViewChild('quickAddMed', { static: true }) quickAddMed: QuickaddmedicationComponent;

	constructor(medSvc: MedicationService) {
		this.medicationService = medSvc;
		this.imageList = [];
		this.medicationImages = new MatTableDataSource<ImgVerify>();
		this.submittedImgVerify = new EventEmitter();
		this.cancelImgVerify = new EventEmitter();
	}

	ngOnInit() {

	}
	doShow(NDC: string, sampledDate: string, sampledBy: string): void {
		this.ndcNumber = NDC;
		this.sampledBy = sampledBy;
		this.sampledDate = sampledDate;
		this.loadImageRecords();
	}
	loadImageRecords(): void {

		this.medicationService.getMedicationByNDC(this.ndcNumber).subscribe(
			(data) => {
				this.selectedMedication = data;
				this.selectedFamily = this.selectedMedication['medicationFamily'];
				this.medicationService.getIngredientsByMedicationFamilyId(this.selectedMedication.medicationFamilyId).subscribe(
					(data1) => {
						this.ingredients = data1;
						this.medicationService.getMedicationImagesByNDC(this.ndcNumber).subscribe(
							(data2) => {

								if (data2.length === 0) {
									this.medicationImages = new MatTableDataSource<ImgVerify>();
									this.noImageFlag = true;
									return;
								}

								this.imageList = new Array();

								for (let i = 0; i < data2.length; i++) {
									const img = new ImgVerify();
									img.imageType = data2[i].imageType;
									img.imageUrl = data2[i].imageUrl;
									img.id = data2[i].id;
									this.imageList.push(img);
								}
								this.medicationImages = new MatTableDataSource<ImgVerify>(this.imageList);
							},
							(error2) => {
								Settings.getInstance().handleError(error2, 'getMedicationImagesByNDC - doSelectImage()');
							});
					},
					(error1) => {
						Settings.getInstance().handleError(error1, 'getIngredientsByMedicationFamilyId()');
					});
			},
			(error) => {
				Settings.getInstance().handleError(error, 'getMedicationByNDC - getMedicationByNDC()');
			});


	}
	tableKeyDown(event: any): void {

	}
	onRowClicked(row: any): void {

	}
	setRecord(): void {

	}
	doMouseOverImage(event: any): void {

		if (event.currentTarget !== undefined) {
			this.largeImgUrl = event.currentTarget.src;
			this.dispLargeImage = true;
		}
	}
	doMouseOutImage(): void {
		if (this.dispLargeImage === true) {
			this.dispLargeImage = false;
		}
	}
	hasCheckedItems(): boolean {

		if (this.medicationImages === undefined) { return; }

		let checkCount = 0;
		checkCount = this.medicationImages.data.filter(x => x.select === true).length;
		return checkCount > 0 ? true : false;
	}
	doSubmitImgVerify(): void {
		const obj = new ImageUrls();
		obj.tabletUrl = this.returnURL('Dose');
		obj.containerUrl = this.returnURL('Container');
		obj.sampledBy = this.sampledBy;
		obj.sampledDate = this.sampledDate;
		this.submittedImgVerify.emit(obj);
	}
	returnURL(imageType: string): string {

		const medImages =
			this.medicationImages.data.find(x => x.imageType === imageType && x.select === true);

		if (medImages === undefined) { return ''; }

		return medImages.imageUrl;
	}
	doCancelImgVerify(): void {

		this.cancelImgVerify.emit();
	}

	verifyDosage() {
		this.sampledBy = Settings.getInstance().loggedInUser.username;
		const today = new Date();
		this.sampledDate = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
	}
	getFullUserName(username) {
		return Settings.getInstance().getResourceFullName(username);
	}

	calculateCostPerUnit(cost: number, packageSize: number): string {
		return packageSize > 0 ? (cost / packageSize).toFixed(2) : '0.00';
	}

	getManufacturerName(id: number): string {
		//const manufacturer = this.manufacturers?.find(m => m.id === id);

		//Settings.getInstance().manufa
		//return manufacturer ? manufacturer.name : 'Unknown';

		return 'Unknown';
	}

	isVerifyDisabled(): boolean {
		return !this.medicationImages.data.some(img => img.imageType === 'Dose' && img.select === true);
	}

	onCheckboxChange(): void {
		if (this.isVerifyDisabled()) {
			this.sampledBy = null;
			this.sampledDate = null;
		}
	}

	public setSelectedManufacturerName(id: number, arr: string): string {
		try {
			if (arr === 'for') {
				return Settings.getInstance().manufactureForList.find(s => s.id === id).description;
			}
			else {
				return Settings.getInstance().manufactureByList.find(s => s.id === id).description;
			}
		} catch (err) {
			return 'Unknown';
		}
	}

	openQuickaddEditMedicationDlg() {
		if (!this.selectedMedication) {
			return;
		}
		this.displayQuickMedicationAddEditDlg = true;
		this.quickAddMed.onShowHandlerEdit(this.selectedMedication);
	}

	public setMedicationRecord($event) {
		this.ndcNumber = $event.origNdcNumber;
		this.loadImageRecords();
		this.displayQuickMedicationAddEditDlg = false;
	}
}


